var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-context-menu-item",class:{disabled:_vm.innderDisabled},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('span',{class:_vm.icon}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33c33604","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/dropdown-menu/src/ui-dropdown-menu-item.vue
// module id = 681
// module chunks = 0